import { Routes } from '@/src/common/enums/routes'
import { VerifyPhoneOTP } from '@/src/common/components/VerifyPhoneOTP'
import { useSardine } from '@/src/services/Sardine'
import { useEffect } from 'react'

export default function VerifyPhoneOTPCardApplication() {
  const { updateOptions } = useSardine()

  useEffect(() => {
    void updateOptions({ flow: 'account-creation-verify-phone-otp' })
  }, [updateOptions])

  return <VerifyPhoneOTP backButtonHref={Routes.AccountCreation.route} disclaimer={false} />
}
